import { useLanguage } from "@/hooks/useLanguage";

export default function CookiePage() {
  const { language } = useLanguage();
  const t = (it: string, es: string, en: string) => (language === 'es' ? es : language === 'en' ? en : it);
  return (
    <div className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-2xl font-semibold mb-4">{t('Cookie Policy', 'Política de Cookies', 'Cookie Policy')}</h1>
      <p className="mb-2 text-white/90">
        {t(
          'Questa pagina spiega le categorie di cookie utilizzate (necessari, analitici, marketing, preferenze) e come puoi gestirli.',
          'Esta página explica las categorías de cookies utilizadas (necesarias, analíticas, marketing, preferencias) y cómo puede gestionarlas.',
          'This page explains cookie categories used (necessary, analytics, marketing, preferences) and how you can manage them.'
        )}
      </p>
      <p className="text-white/90">
        {t(
          'Puoi modificare o revocare il consenso in qualsiasi momento tramite “Gestisci cookie”.',
          'Puede modificar o revocar el consentimiento en cualquier momento mediante “Gestionar cookies”.',
          'You can change or revoke consent at any time via “Manage cookies”.'
        )}
      </p>
    </div>
  );
}